export default [
  {
    path: '/category-selector',
    name: 'category-selector',
    component: () => import('./views/category/category'),
  },
  {
    path: '/portal',
    name: 'portal',
    component: () => import('./views/portal/portal'),
  },
  {
    path: '/',
    name: 'default',
    component: () => import('./views/dashboards/default'),
  },
  {
    path: '/test',
    name: 'default',
    component: () => import('./views/dashboards/test'),
  },
  {
    path: '/test2',
    name: 'default',
    component: () => import('./views/dashboards/test2'),
  },
  {
    path: '/logout',
    name: 'logout',
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('./views/account/login'),
  },
  {
    path: '/login/kc/callback',
    name: 'login-kc-callback',
    component: () => import('./views/account/keycloak-callback'),
  },
  {
    path: '/404',
    name: '404',
    component: require('./views/utility/404').default,
  },
  {
    path: '*',
    redirect: '404',
  },
  {
    path: '/pages/maintenance',
    name: 'Maintenance',
    component: () => import('./views/utility/maintenance')
  },
  {
    path: '/pages/401',
    name: 'Error-401',
    meta: { authRequired: true },
    component: () => import('./views/utility/401')
  },
  {
    path: '/pages/404',
    name: 'Error-404',
    meta: { authRequired: true },
    component: () => import('./views/utility/404')
  },
  {
    path: '/pages/500',
    name: 'Error-500',
    meta: { authRequired: true },
    component: () => import('./views/utility/500')
  },
  {
    path: '/applications',
    name: 'applications',
    meta: { authRequired: true },
    component: () => import('./views/applications/index')
  },
  {
    path: '/applications/:id/services/:serviceId/parameters/:parameterId',
    name: 'parameter_detail',
    meta: { authRequired: true },
    component: () => import('./views/applications/services/parameters/detail')
  },
  {
    path: '/applications/:id/services/:serviceId',
    name: 'service_detail',
    meta: { authRequired: true },
    component: () => import('./views/applications/services/detail')
  },
  {
    path: '/applications/:id',
    name: 'application_detail',
    meta: { authRequired: true },
    component: () => import('./views/applications/detail')
  },
  {
    path: '/users',
    name: 'users',
    meta: { authRequired: true },
    component: () => import('./views/users/index')
  },
  {
    path: '/users/:id',
    name: 'user_detail',
    meta: { authRequired: true },
    component: () => import('./views/users/detail')
  },
  {
    path: '/groups',
    name: 'groups',
    meta: { authRequired: true },
    component: () => import('./views/groups/index')
  },
  {
    path: '/groups/:id',
    name: 'groups_detail',
    meta: { authRequired: true },
    component: () => import('./views/groups/detail')
  },
  {
    path: '/permissions',
    name: 'permissions',
    meta: { authRequired: true },
    component: () => import('./views/permissions/index')
  },
  {
    path: '/permissions/:id',
    name: 'permissions_detail',
    meta: { authRequired: true },
    component: () => import('./views/permissions/detail')
  },
  {
    path: '/view-interface',
    name: 'view-interface',
    meta: { authRequired: true },
    component: () => import('./views/view-interface/index')
  },
  {
    path: '/group-users',
    name: 'group_users',
    meta: { authRequired: true },
    component: () => import('./views/group-users/index')
  },
  {
    path: '/view-permission',
    name: 'view-permissions',
    meta: { authRequired: true },
    component: () => import('./views/view-permission/index')
  },
  {
    path: '/group-view-permission',
    name: 'group-view-permissions',
    meta: { authRequired: true },
    component: () => import('./views/group-view-permission/index')
  },
  {
    path: '/user-view-permission',
    name: 'user-view-permissions',
    meta: { authRequired: true },
    component: () => import('./views/user-view-permission/index')
  },
  {
    path: '/system-logs',
    name: 'system_logs',
    meta: { authRequired: true },
    component: () => import('./views/system-logs/index')
  },
  {
    path: '/system-logs/:id',
    name: 'system_log_detail',
    meta: { authRequired: true },
    component: () => import('./views/system-logs/detail')
  },
  {
    path: '/document-logs',
    name: 'document_logs',
    meta: { authRequired: true },
    component: () => import('./views/document-logs/index')
  }, 
  {
    path: '/client-apps/:id',
    name: 'client_apps_detail',
    meta: { authRequired: true },
    component: () => import('./views/client-apps/detail')
  },
  {
    path: '/client-apps',
    name: 'client_apps',
    meta: { authRequired: true },
    component: () => import('./views/client-apps/index')
  },
    {
    path: '/service-client-apps',
    name: 'service_client_apps',
    meta: { authRequired: true },
    component: () => import('./views/service-client-apps/index')
  },
      {
    path: '/tech-products',
    name: 'tech_products',
    meta: { authRequired: true },
    component: () => import('./views/tech-products/index')
  },
  {
    path: '/tech-products/:id',
    name: 'tech_products_detail',
    meta: { authRequired: true },
    component: () => import('./views/tech-products/detail')
  },
  {
    path: '/tech-products/:id/client-apps/:client_apps_id',
    name: 'tech_products_apply_client_apps',
    meta: { authRequired: true },
    component: () => import('./views/tech-products/apply-client-apps')
  },
  // consumer log section
  {
    path: '/consumer-logs',
    name: 'consumer_logs',
    meta: { authRequired: true },
    component: () => import('./views/consumer-logs/index')
  },
  {
    path: '/consumer-logs/:id',
    name: 'consumer_logs',
    meta: { authRequired: true },
    component: () => import('./views/consumer-logs/detail')
  },
  
  {
    path: '/roles',
    name: 'roles',
    meta: { authRequired: true },
    component: () => import('./views/roles/index')
  },
  {
    path: '/roles/:id',
    name: 'roles_detail',
    meta: { authRequired: true },
    component: () => import('./views/roles/detail')
  },
  // end consumer log section
]
